export default "__VITE_ASSET__2935d974__"